<template>
    <rkm-overlay>
        <rkm-layout-body title="Parametrização">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :key="key"
                    @saved="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/parametrizacao/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        key: 1,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleSave() {
            this.key = this.key + 1
            this.unsetShowExitFormConfirmation()
        },
    },
}
</script>